// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function bankTransferOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'banktransfer',
    payment_type_code: 'banktransfer',
    instalments: '1',
  };
}
